import { gql } from 'apollo-boost';
const getLookalikeModelRowsQuery = gql `
	{
		lookalikeModelRows {
			id
			type
			status
			jobId
			fileName
			targetId
			segmentName
			targetName
		}
	}
`;
const getLookalikeModelRowInfoQuery = gql `
	query ($rowId: Int!) {
		lookalikeModelRowInfo(rowId: $rowId)
	}
`;
const mutationCreateLookalikeModelRow = gql `
	mutation ($lookalikeId: String!, $days: Int, $lalType: String!) {
		createLookalikeModelRow(lookalikeId: $lookalikeId, days: $days, lalType: $lalType) {
			ok
			message
		}
	}
`;
const mutationCheckStatusLookalikeModelRow = gql `
	mutation ($rowId: Int!, $runId: Int!) {
		checkStatusLookalikeModelRow(rowId: $rowId, runId: $runId) {
			ok
			message
		}
	}
`;
export { getLookalikeModelRowsQuery, getLookalikeModelRowInfoQuery, mutationCreateLookalikeModelRow, mutationCheckStatusLookalikeModelRow };
